// Public-facing bundle — no Chart.js (admin only)
import * as Turbo from "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";

const application = Application.start();
window.Stimulus = application;
application.debug = false;

import ModalController from "./controllers/modal_controller";
import OfferController from "./controllers/offer_controller";
import GeolocationController from "./controllers/geolocation_controller";
import NavController from "./controllers/nav_controller";
import SearchController from "./controllers/search_controller";
import TagsController from "./controllers/tags_controller";
import TimeAgoController from "./controllers/time_ago_controller";
import CouponController from "./controllers/coupon_controller";
import GalleryController from "./controllers/gallery_controller";
import SkeletonController from "./controllers/skeleton_controller";
import VisitorController from "./controllers/visitor_controller";
import CountdownController from "./controllers/countdown_controller";
import StickyCtaController from "./controllers/sticky_cta_controller";
import AiPricingController from "./controllers/ai_pricing_controller";
import UploadController from "./controllers/upload_controller";
import NotificationsController from "./controllers/notifications_controller";
import LiveToastController from "./controllers/live_toast_controller";
import ThemeController from "./controllers/theme_controller";
import LazyMapController from "./controllers/lazy_map_controller";
import ClinicLocationsController from "./controllers/clinic_locations_controller";
import CountUpController from "./controllers/count_up_controller";
import ParallaxController from "./controllers/parallax_controller";
import ScrollRevealController from "./controllers/scroll_reveal_controller";
import DropdownController from "./controllers/dropdown_controller";
import CookieConsentController from "./controllers/cookie_consent_controller";

application.register("modal", ModalController);
application.register("offer", OfferController);
application.register("geolocation", GeolocationController);
application.register("nav", NavController);
application.register("search", SearchController);
application.register("tags", TagsController);
application.register("time-ago", TimeAgoController);
application.register("coupon", CouponController);
application.register("gallery", GalleryController);
application.register("skeleton", SkeletonController);
application.register("visitor", VisitorController);
application.register("countdown", CountdownController);
application.register("sticky-cta", StickyCtaController);
application.register("ai-pricing", AiPricingController);
application.register("upload", UploadController);
application.register("notifications", NotificationsController);
application.register("live-toast", LiveToastController);
application.register("theme", ThemeController);
application.register("lazy-map", LazyMapController);
application.register("clinic-locations", ClinicLocationsController);
application.register("count-up", CountUpController);
application.register("parallax", ParallaxController);
application.register("scroll-reveal", ScrollRevealController);
application.register("dropdown", DropdownController);
application.register("cookie-consent", CookieConsentController);
